// © Microsoft Corporation. All rights reserved.
import { AudienceModeType } from "@msnews/experiences-constants";
import { wpoEnterpriseFlights } from "./Constants";
/**
 * Trim the list of flights to send to wpo by removing Enterprise specific flights from the list
 * if the audience mode is not Enterprise
 * @param flights Full list of flights
 * @returns Trimmed list of flights or the same list if no trimming was necessary
 */
export function trimEnterpriseFlightsIfNecessary(flights, audienceMode) {
    // Don't remove anything if the audience mode is Enterprise
    if (!flights || audienceMode === AudienceModeType.Enterprise) {
        return flights;
    }
    return flights.filter((flightId) => {
        return wpoEnterpriseFlights.indexOf(flightId.toLowerCase(), 0) === -1;
    });
}
//# sourceMappingURL=WpoEnterpriseHelper.js.map